// extracted by mini-css-extract-plugin
export default {"details_block_wrap":"DetailsBlock_details_block_wrap__jXiEg","block_title":"DetailsBlock_block_title__x6SUM","block_details_wrap":"DetailsBlock_block_details_wrap__DBvyA"};